import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_IS_PROVISION_TEAM_IN_PROGRESS', function setIsProvisionTeamInProgress(isProvisioning: boolean) {
    teamSetupPickerStore.isProvisionTeamInProgress = isProvisioning;
});
